import { NeoModel, NotifyUtils } from '@singularsystems/neo-core';
import { Views } from '@singularsystems/neo-react';
import { AppService, Types } from '../../../App/Services/AppService';
import { Data } from '@singularsystems/neo-core';
import InstrumentSearchCriteria from '../../../Maintenance/Instruments/Models/Queries/InstrumentSearchCriteria';
import InstrumentSearchLookup from '../Models/InstrumentSearchLookup';
import { PartialPlainObject } from '@singularsystems/neo-core/dist/Model';
import CreateInstrumentCommand from '../../../Maintenance/Instruments/Models/Commands/CreateInstrumentCommand';
import { NotificationDuration } from '../../../App/Models/Enums/NotificationDuration';
import { TextConstants } from '../../../Common/TextConstants';
import InstrumentMappingsLookup from '../Models/InstrumentMappingLookupModel';
import ManageInstrumentComponentVM from '../../../Maintenance/Instruments/components/ManageInstrumentComponentVM';

@NeoModel
export default class AssignInstrumentComponentVM extends Views.ViewModelBase {

    constructor(
        public instrumentApiClient = AppService.get(Types.ApiClients.InstrumentApiClient),
        taskRunner = AppService.get(Types.Neo.TaskRunner)) {
        super(taskRunner);
    }

    public instrumentSearchCriteria = new InstrumentSearchCriteria();
    public selectedInstrument = new InstrumentSearchLookup();
    public showOnTheFlyInstrumentModal: boolean = false;
    public manageInstrumentComponent = new ManageInstrumentComponentVM();

    public pageManager = new Data.PageManager(this.instrumentSearchCriteria, InstrumentSearchLookup, this.instrumentApiClient.getPagedInstruments, {
        pageSize: 10,
        pageSizeOptions: [10, 20, 50],
        sortAscending: false,
        fetchInitial: true,
        initialTaskRunner: this.taskRunner,
    });

    public async clearSearch() {
        this.instrumentSearchCriteria.meta.searchCriteria.value = "";
        await this.pageManager.refreshData();
    }

    public selectInstrument(selectedInstrument: InstrumentSearchLookup){
        var instruments = this.pageManager.data.filter(c => c.isSelectedInd === true);
        for(var i = 0; i < instruments.length; i++){
            if(instruments[i].instrumentID !== selectedInstrument.instrumentID){
                instruments[i].isSelectedInd = false;
            }
        }
        this.pageManager.data.update(instruments as unknown as PartialPlainObject<InstrumentSearchLookup>[]);
        this.selectedInstrument = selectedInstrument.isSelectedInd === true ? selectedInstrument : new InstrumentSearchLookup();
    }

    public openInstrumentModal(mapping: InstrumentMappingsLookup){
        this.showOnTheFlyInstrumentModal = true;
        this.manageInstrumentComponent.managedInstrument = this.mapMappingToInstrument(mapping);
    }

    public async closeInstrumentModal(justSaved: boolean = false){
        if(justSaved)
        {
            var result = new InstrumentSearchLookup();
            result.set((await this.instrumentApiClient.getInstrumentLookupByISIN(this.manageInstrumentComponent.managedInstrument.isin!)).data);
            if(result.isin !== null)
            {
                await this.clearSearch();
                this.pageManager.data.unshift(result);
                this.pageManager.data[0].isSelectedInd = true;
                this.selectInstrument(this.pageManager.data[0]);
            }
        }
        this.showOnTheFlyInstrumentModal = false;
    }

    public async saveInstrument() {
        this.taskRunner.run(async () => {
            var response = await this.instrumentApiClient.createInstrument((this.mapInstrumentToCreateCommand()!.toJSObject()));
            if (response.data.success) {
                NotifyUtils.addSuccess(TextConstants.Titles.Success, TextConstants.Notifications.InstrumentSavedSuccessfully, NotificationDuration.Standard);
                this.closeInstrumentModal(true);
            }
            else {
                NotifyUtils.add(TextConstants.Titles.Error, response.data.error, "danger" as any, NotificationDuration.Long);
                this.closeInstrumentModal();
            }
        });
    }

    private mapInstrumentToCreateCommand() {
        var command = new CreateInstrumentCommand().mapFrom(this.manageInstrumentComponent.managedInstrument);
        return command;
    }

    private mapMappingToInstrument(mapping: InstrumentMappingsLookup) {
        var end = new InstrumentSearchLookup();
        end.description = mapping.description;
        end.ticker = mapping.instrumentCode;
        end.isin = mapping.isin;
        end.isListedInstrumentInd = true;
        end.isDeletedInd = false;
        return end;
    }
}